
<div style="z-index: 1000;
        display: -webkit-box;
        display: -moz-box;
        display: -webkit-flex;
        display: flex;
        -webkit-box-flex-direction: row;
        -moz-box-flex-direction: row;
        -webkit-flex-direction: row;
        flex-direction: row;
        position: fixed;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background: #fff">
  <div style="margin: auto; text-align:center; height: 110px">
    <img style="width:350px; max-width: 90%" src="https://www.firstmac.com.au/media/Images/logo-firstmac.png" /><br /><br /><br />
    <h2>Wizard Applications</h2>
    <hr/>
    <h3><small>Unauthorized</small></h3>
    <hr/>
  </div>
</div>
